import { lazy } from 'react';
import { routes } from '~/constants';
import { FeatureFlag } from '~/featureFlags';
import { UserRole } from '~/models';
import AdditionalPaymentProcessorInfoPage from '~/pages/AdditionalPaymentProcessorInfoPage/AdditionalPaymentProcessorInfoPage';
import { NoAccessPage } from '~/pages/NoAccessPage/NoAccessPage';
import { Notification } from '~/pages/Notification/Notification';
import { NotificationActionPage } from '~/pages/NotificationAction';
import { OAuthAuthorizePage } from '~/pages/OAuthAuthorizePage';
import { RedirectPage } from '~/pages/RedirectPage';
import { ResetPasswordScreen, SetPasswordScreen, SignupScreen } from '~/pages/unAuthorizedPages';
const importClientOnboarding = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/client-flow/clientOb/ClientOnboarding');
const importAllSetPage = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/client-flow/clientOb/AllSetStep/AllSetPage');
const importNoPermissionsRelationshipApproved = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/client-flow/clientOb/AllSetStep/noPermissionsRelationshipApproved');
const importRelationshipApprovedWithAnimations = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/client-flow/clientOb/RelationshipSignedStep/RelationshipApprovedWithAnimations');
const importCanceledProposalPage = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/components/CanceledProposalPage/CanceledProposalPage');
const importExpiredProposalPage = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/components/ExpiredProposalPage/ExpiredProposalPage');
const importBankVerification = ()=>import(/* webpackChunkName: "client-onboarding" */ '~/pages/AdHocInvoiceApproval/BankVerification/BankVerification').then((m)=>({
            default: m.BankVerification
        }));
const importAgreementStudioPage = ()=>import(/* webpackChunkName: "agreement-studio" */ '~/components/AgreementStudioPage/AgreementStudioPage');
const importAgreementStudioTemplates = ()=>import(/* webpackChunkName: "agreement-studio" */ '~/components/AgreementStudioPage/AgreementStudioTemplateMode/AgreementStudioTemplates');
const importEditAgreementPage = ()=>import(/* webpackChunkName: "agreement-studio" */ '~/components/EditAgreementModal/EditAgreementPage').then((m)=>({
            default: m.EditAgreementPage
        }));
const importProposalTemplateLoader = ()=>import(/* webpackChunkName: "agreement-studio" */ '~/pages/ProposalTemplates/ProposalTemplateLoader');
const importAgreementMinisite = ()=>import(/* webpackChunkName: "agreement-minisite" */ '~/pages/AgreementMinisite/AgreementMinisite');
const importVendorOnboardingPage = ()=>import(/* webpackChunkName: "vendor-onboarding" */ '~/pages/VendorOnboarding/VendorOnboardingPage').then((m)=>({
            default: m.VendorOnboardingPage
        }));
const importVendorDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/VendorDashboard/VendorDashboard').then((m)=>({
            default: m.VendorDashboard
        }));
const importAgreementsDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/AgreementsDashboard/AgreementsDashboard').then((m)=>({
            default: m.AgreementsDashboard
        }));
const importProposalsDashboardOld = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ProposalsDashboard').then((m)=>({
            default: m.ProposalsDashboardOld
        }));
const importProposalsDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ProposalsDashboard').then((m)=>({
            default: m.ProposalsDashboard
        }));
const importDraftsDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/DraftsDashboard').then((m)=>({
            default: m.DraftsDashboard
        }));
const importArchivedProposalsDashboardOld = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ArchivedProposalsDashboard/ArchivedProposalsDashboardOld').then((m)=>({
            default: m.ArchivedProposalsDashboardOld
        }));
const importArchivedProposalsDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ArchivedProposalsDashboard/ArchivedProposalsDashboard').then((m)=>({
            default: m.ArchivedProposalsDashboard
        }));
const importInvoicesDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/InvoicesDashboard/InvoicesDashboard');
const importPayoutsDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/PayoutsDashboard/PayoutsDashboard');
const importContactsDashboardTableOld = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ContactsDashboard/ContactsDashboardTableOld').then((m)=>({
            default: m.ContactsDashboardTableOld
        }));
const importContactsDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ContactsDashboard/ContactsDashboard').then((m)=>({
            default: m.ContactsDashboard
        }));
const importContactsDashboardOld = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ContactsDashboardOld').then((m)=>({
            default: m.ContactsDashboardOld
        }));
const importContactsDashboardLegacy = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ContactsDashboardOld/ContactsDashboard').then((m)=>({
            default: m.ContactsDashboard
        }));
const importClientsPage = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ClientsPage/ClientsPage').then((m)=>({
            default: m.ClientsPage
        }));
const importClientsPageOld = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ClientsPage/ClientsPageOld').then((m)=>({
            default: m.ClientsPageOld
        }));
const importGlobalBillingHub = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/GlobalBillingHub/GlobalBillingHub');
const importAdHocInvoiceApproval = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/AdHocInvoiceApproval/AdHocInvoiceApprovalPage').then((m)=>({
            default: m.AdHocInvoiceApprovalPage
        }));
const importProposalTemplates = ()=>import(/* webpackChunkName: "proposals-config" */ '~/pages/ProposalTemplates/ProposalTemplates').then((m)=>({
            default: m.ProposalTemplates
        }));
const importProposalTemplatesOld = ()=>import(/* webpackChunkName: "proposals-config" */ '~/pages/ProposalTemplates/ProposalTemplatesOld').then((m)=>({
            default: m.ProposalTemplatesOld
        }));
const importProposalDefaults = ()=>import(/* webpackChunkName: "proposals-config" */ '~/pages/ProposalDefaults/ProposalDefaults');
const importServicesPage = ()=>import(/* webpackChunkName: "services-library" */ '~/pages/ServicesLibrary/ServicesPage/ServicesPage').then((m)=>({
            default: m.ServicesPage
        }));
const importServicesPageOld = ()=>import(/* webpackChunkName: "services-library" */ '~/pages/ServicesLibrary/ServicesPage/ServicesPageOld').then((m)=>({
            default: m.ServicesPageOld
        }));
const importBundlesPageOld = ()=>import(/* webpackChunkName: "services-library" */ '~/pages/ServicesLibrary/BundlesPage/BundlesPageOld').then((m)=>({
            default: m.BundlesPageOld
        }));
const importBundlesPage = ()=>import(/* webpackChunkName: "services-library" */ '~/pages/ServicesLibrary/BundlesPage/BundlesPage').then((m)=>({
            default: m.BundlesPage
        }));
const importAvailableAppsPage = ()=>import(/* webpackChunkName: "integrations" */ '~/integrations/AvailableAppsPage/AvailableAppsPage').then((m)=>({
            default: m.AvailableAppsPage
        }));
const importConnectedAppsPage = ()=>import(/* webpackChunkName: "integrations" */ '~/pages/ConnectedAppsPage/ConnectedAppsPage');
const importAPIKeysPage = ()=>import(/* webpackChunkName: "integrations" */ '~/pages/APIKeysPage/APIKeysPage').then((m)=>({
            default: m.APIKeysPage
        }));
const importAPIKeysPageOld = ()=>import(/* webpackChunkName: "integrations" */ '~/pages/APIKeysPage/APIKeysPageOld');
const importProfilePage = ()=>import(/* webpackChunkName: "settings" */ '~/pages/Profile/Profile');
const importBusinessDetails = ()=>import(/* webpackChunkName: "settings" */ '~/pages/BusinessDetails').then((m)=>({
            default: m.BusinessDetails
        }));
const importSalesTaxSettings = ()=>import(/* webpackChunkName: "settings" */ '~/pages/SalesTaxSettings/SalesTaxSettings').then((m)=>({
            default: m.SalesTaxSettings
        }));
const importTeamPage = ()=>import(/* webpackChunkName: "settings" */ '~/pages/TeamPage/TeamPage').then((m)=>({
            default: m.TeamPage
        }));
const importTeamPageOld = ()=>import(/* webpackChunkName: "settings" */ '~/pages/TeamPage/TeamPageOld');
const importAnchorBilling = ()=>import(/* webpackChunkName: "settings" */ '~/pages/AnchorBilling/AnchorBilling').then((m)=>({
            default: m.AnchorBilling
        }));
const importAnchorBillingOld = ()=>import(/* webpackChunkName: "settings" */ '~/pages/AnchorBilling/AnchorBillingOld');
const importNotificationSettings = ()=>import(/* webpackChunkName: "settings" */ '~/pages/NotificationSettings/NotificationSettings').then((m)=>({
            default: m.NotificationSettings
        }));
const importImportAgreements = ()=>import(/* webpackChunkName: "imports" */ '~/pages/ImportAgreements/ImportAgreements');
const importImportServices = ()=>import(/* webpackChunkName: "imports" */ '~/pages/ImportServices/ImportServices').then((m)=>({
            default: m.ImportServices
        }));
const importImportContacts = ()=>import(/* webpackChunkName: "imports" */ '~/pages/ImportContacts/ImportContacts').then((m)=>({
            default: m.ImportContacts
        }));
const importReports = ()=>import(/* webpackChunkName: "reports" */ '~/pages/Reports/Reports').then((m)=>({
            default: m.Reports
        }));
const importActivityLogsPage = ()=>import(/* webpackChunkName: "reports" */ '~/pages/ActivityLogsPage/ActivityLogsPage');
const importReferralDashboard = ()=>import(/* webpackChunkName: "dashboards" */ '~/pages/ReferralDashboard/ReferralDashboard').then((m)=>({
            default: m.ReferralDashboard
        }));
const importHomePage = ()=>import(/* webpackChunkName: "home" */ '~/pages/HomePage/HomePage').then((m)=>({
            default: m.HomePage
        }));
export const ROUTE_CHUNK_IMPORTERS = {
    home: importHomePage,
    dashboards: importVendorDashboard,
    'proposals-config': importProposalTemplates,
    'services-library': importServicesPage,
    integrations: importAvailableAppsPage,
    settings: importProfilePage,
    reports: importReports,
    'agreement-studio': importAgreementStudioPage,
    'agreement-minisite': importAgreementMinisite,
    imports: importImportAgreements
};
const AllSetPage = lazy(importAllSetPage);
const NoPermissionsRelationshipApproved = lazy(importNoPermissionsRelationshipApproved);
const ClientOnboarding = lazy(importClientOnboarding);
const RelationshipApprovedWithAnimations = lazy(importRelationshipApprovedWithAnimations);
const AgreementStudioPage = lazy(importAgreementStudioPage);
const AgreementStudioTemplates = lazy(importAgreementStudioTemplates);
const CanceledProposalPage = lazy(importCanceledProposalPage);
const EditAgreementPage = lazy(importEditAgreementPage);
const ExpiredProposalPage = lazy(importExpiredProposalPage);
const BankVerification = lazy(importBankVerification);
const AvailableAppsPage = lazy(importAvailableAppsPage);
const ActivityLogsPage = lazy(importActivityLogsPage);
const AdHocInvoiceApproval = lazy(importAdHocInvoiceApproval);
const AgreementMinisite = lazy(importAgreementMinisite);
const AgreementsDashboard = lazy(importAgreementsDashboard);
const AnchorBilling = lazy(importAnchorBilling);
const AnchorBillingOld = lazy(importAnchorBillingOld);
const APIKeysPage = lazy(importAPIKeysPage);
const APIKeysPageOld = lazy(importAPIKeysPageOld);
const ArchivedProposalsDashboard = lazy(importArchivedProposalsDashboard);
const ArchivedProposalsDashboardOld = lazy(importArchivedProposalsDashboardOld);
const BusinessDetails = lazy(importBusinessDetails);
const ClientsPage = lazy(importClientsPage);
const ClientsPageOld = lazy(importClientsPageOld);
const ConnectedAppsPage = lazy(importConnectedAppsPage);
const ContactsDashboard = lazy(importContactsDashboard);
const ContactsDashboardTableOld = lazy(importContactsDashboardTableOld);
const ContactsDashboardOld = lazy(importContactsDashboardOld);
const ContactsDashboardLegacy = lazy(importContactsDashboardLegacy);
const DraftsDashboard = lazy(importDraftsDashboard);
const GlobalBillingHub = lazy(importGlobalBillingHub);
const HomePage = lazy(importHomePage);
const ImportAgreements = lazy(importImportAgreements);
const ImportContacts = lazy(importImportContacts);
const ImportServices = lazy(importImportServices);
const InvoicesDashboard = lazy(importInvoicesDashboard);
const NotificationSettings = lazy(importNotificationSettings);
const PayoutsDashboard = lazy(importPayoutsDashboard);
const ProfilePage = lazy(importProfilePage);
const ProposalDefaults = lazy(importProposalDefaults);
const ProposalsDashboard = lazy(importProposalsDashboard);
const ProposalsDashboardOld = lazy(importProposalsDashboardOld);
const ProposalTemplateLoader = lazy(importProposalTemplateLoader);
const ProposalTemplates = lazy(importProposalTemplates);
const ProposalTemplatesOld = lazy(importProposalTemplatesOld);
const ReferralDashboard = lazy(importReferralDashboard);
const Reports = lazy(importReports);
const SalesTaxSettings = lazy(importSalesTaxSettings);
const BundlesPage = lazy(importBundlesPage);
const BundlesPageOld = lazy(importBundlesPageOld);
const ServicesPage = lazy(importServicesPage);
const ServicesPageOld = lazy(importServicesPageOld);
const TeamPage = lazy(importTeamPage);
const TeamPageOld = lazy(importTeamPageOld);
const VendorDashboard = lazy(importVendorDashboard);
const VendorOnboardingPage = lazy(importVendorOnboardingPage);
export const unauthorizedPages = [
    {
        url: routes.signUp,
        component: SignupScreen,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.setPassword,
        component: SetPasswordScreen,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.resetPassword,
        component: ResetPasswordScreen,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.notification(),
        component: Notification,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.noPermissionsRelationshipAlreadyApproved,
        component: NoPermissionsRelationshipApproved,
        supportsMobileViewport: true,
        enableIntercom: false
    },
    {
        url: routes.allSignaturesAcquired(),
        component: RelationshipApprovedWithAnimations,
        supportsMobileViewport: true,
        enableIntercom: false
    },
    {
        url: routes.expiredProposalPage,
        component: ExpiredProposalPage,
        supportsMobileViewport: true,
        enableIntercom: false
    },
    {
        url: routes.canceledProposalPage,
        component: CanceledProposalPage,
        supportsMobileViewport: true,
        enableIntercom: false
    },
    {
        url: routes.additionalPaymentProcessorInfo,
        component: AdditionalPaymentProcessorInfoPage,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.notificationAction,
        component: NotificationActionPage,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.noAccessPage,
        component: NoAccessPage,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.adHocInvoiceApproval(),
        component: AdHocInvoiceApproval,
        supportsMobileViewport: true,
        supportsMobileDevice: true,
        enableIntercom: false
    },
    {
        url: routes.adHocBankVerification(),
        component: BankVerification,
        supportsMobileViewport: true,
        supportsMobileDevice: true,
        enableIntercom: false
    }
];
export const getAuthorizedPages = ()=>{
    const pages = [
        {
            url: routes.redirect,
            component: RedirectPage,
            supportsMobileViewport: true,
            allowPartiallyOnboardedVendor: true,
            enableIntercom: true
        },
        {
            url: routes.home,
            component: HomePage,
            allowPartiallyOnboardedVendor: true,
            deniedToRoles: [
                UserRole.Reviewer
            ],
            enableIntercom: true,
            supportsMobileViewport: false,
            supportsMobileDevice: false
        },
        {
            url: routes.agreementStudio,
            component: AgreementStudioPage,
            vendorOnly: true,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.editAgreement(),
            component: EditAgreementPage,
            vendorOnly: true,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.proposalTemplateStudio,
            component: AgreementStudioTemplates,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.draft(),
            component: AgreementStudioPage,
            vendorOnly: true,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.proposalTemplate(),
            component: ProposalTemplateLoader,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.clientOnboarding(),
            component: ClientOnboarding,
            supportsMobileViewport: true,
            enableIntercom: false
        },
        {
            url: routes.allSet(),
            component: AllSetPage,
            supportsMobileViewport: true,
            enableIntercom: false
        }
    ];
    pages.push({
        url: routes.oauthAuthorize,
        component: OAuthAuthorizePage,
        supportsMobileViewport: true,
        supportsMobileDevice: true,
        enableIntercom: false
    });
    pages.push({
        url: routes.vendorOnboarding,
        component: VendorOnboardingPage,
        allowPartiallyOnboardedVendor: true,
        enableIntercom: false,
        supportsMobileViewport: true,
        supportsMobileDevice: true
    });
    return pages;
};
export function getHomePagePages(featureFlags) {
    const isNotificationsMobileEnabled = featureFlags[FeatureFlag.NOTIFICATION_CONTENT_CUSTOMIZATION] === true;
    const isCrmEnabled = featureFlags[FeatureFlag.FE_CRM] === true;
    const isSalesTaxEnabled = featureFlags[FeatureFlag.SALES_TAX] === true;
    const isContactsTableEnabled = featureFlags[FeatureFlag.CRM_CONTACTS] === true;
    const isSeagullTablesEnabled = featureFlags[FeatureFlag.SEAGULL_TABLES] === true;
    const routeConfigs = [
        {
            url: routes.vendorDashboard,
            component: VendorDashboard,
            supportsMobileDevice: true,
            supportsMobileViewport: true,
            enableIntercom: true
        },
        {
            url: routes.agreementsDashboard,
            component: AgreementsDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.proposalsDashboard,
            component: isSeagullTablesEnabled ? ProposalsDashboard : ProposalsDashboardOld,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.draftsDashboard,
            component: DraftsDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.archivedProposals,
            component: isSeagullTablesEnabled ? ArchivedProposalsDashboard : ArchivedProposalsDashboardOld,
            enableIntercom: true
        },
        {
            url: routes.proposalTemplates,
            component: isSeagullTablesEnabled ? ProposalTemplates : ProposalTemplatesOld,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.proposalDefaults,
            component: ProposalDefaults,
            enableIntercom: true
        },
        {
            url: routes.invoicesDashboard,
            component: InvoicesDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.payoutsDashboard,
            component: PayoutsDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.contacts,
            component: !(isCrmEnabled && isContactsTableEnabled) ? isSeagullTablesEnabled ? ContactsDashboardLegacy : ContactsDashboardOld : isSeagullTablesEnabled ? ContactsDashboard : ContactsDashboardTableOld,
            supportsMobileDevice: true,
            supportsMobileViewport: true,
            enableIntercom: true
        },
        ...isCrmEnabled ? [
            {
                url: routes.clients,
                component: isSeagullTablesEnabled ? ClientsPage : ClientsPageOld,
                supportsMobileDevice: true,
                supportsMobileViewport: true,
                enableIntercom: true
            }
        ] : [],
        {
            url: routes.serviceLibrary,
            component: isSeagullTablesEnabled ? ServicesPage : ServicesPageOld,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.bundlesLibrary,
            component: isSeagullTablesEnabled ? BundlesPage : BundlesPageOld,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.availableApps,
            component: AvailableAppsPage,
            enableIntercom: true
        },
        {
            url: routes.notifications,
            component: NotificationSettings,
            supportsMobileDevice: isNotificationsMobileEnabled,
            supportsMobileViewport: isNotificationsMobileEnabled,
            enableIntercom: true
        },
        {
            url: routes.profile,
            component: ProfilePage,
            supportsMobileDevice: true,
            supportsMobileViewport: true,
            enableIntercom: true
        },
        {
            url: routes.businessDetails,
            component: BusinessDetails,
            enableIntercom: true
        },
        ...isSalesTaxEnabled ? [
            {
                url: routes.salesTax,
                component: SalesTaxSettings,
                enableIntercom: true
            }
        ] : [],
        {
            url: routes.team,
            component: isSeagullTablesEnabled ? TeamPage : TeamPageOld,
            enableIntercom: true
        },
        {
            url: routes.anchorBilling,
            component: isSeagullTablesEnabled ? AnchorBilling : AnchorBillingOld,
            enableIntercom: true
        },
        {
            url: routes.importAgreements,
            component: ImportAgreements,
            enableIntercom: true
        },
        {
            url: routes.importServices,
            component: ImportServices,
            enableIntercom: true
        },
        {
            url: routes.importContacts,
            component: ImportContacts,
            enableIntercom: true
        },
        {
            url: routes.minisite(undefined),
            component: AgreementMinisite,
            supportsMobileDevice: true,
            supportsMobileViewport: true,
            enableIntercom: true
        },
        {
            url: routes.globalBillingHub,
            component: GlobalBillingHub,
            supportsMobileDevice: true,
            supportsMobileViewport: true,
            enableIntercom: true
        },
        {
            url: routes.referrals,
            component: ReferralDashboard,
            enableIntercom: true
        },
        {
            url: routes.reports,
            component: Reports,
            enableIntercom: true
        },
        {
            url: routes.anchorApiKeys,
            component: isSeagullTablesEnabled ? APIKeysPage : APIKeysPageOld,
            enableIntercom: true
        },
        {
            url: routes.connectedApps,
            component: ConnectedAppsPage,
            enableIntercom: true
        },
        {
            url: routes.activityLogs,
            component: ActivityLogsPage,
            enableIntercom: true
        }
    ];
    return routeConfigs;
}
